import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

type OfferFullFillIconProps = {
  size: number;
  color?: string;
};

export default class OfferFullFillIconSVG extends React.Component<OfferFullFillIconProps> {
  render() {
    return (
      <Svg
        width={this.props.size}
        height={this.props.size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <Path
          d="M4.571 10v18.688c0 2.125.841 4.162 2.348 5.662l22.095 22a8.056 8.056 0 0011.362 0l16.76-16.688a7.973 7.973 0 000-11.312l-22.096-22a8.055 8.055 0 00-5.687-2.338H10.597C7.27 4 4.571 6.687 4.571 10zm14.06 4c1.066 0 2.088.421 2.842 1.172a3.991 3.991 0 010 5.656 4.026 4.026 0 01-5.682 0 3.991 3.991 0 010-5.656A4.026 4.026 0 0118.631 14z"
          fill={this.props.color || '#003349'}
        />
      </Svg>
    );
  }
}
